<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <div class="logo">Private Banking</div>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" placeholder="Enter your email">
          @if (loginForm.get('email')?.hasError('required')) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (loginForm.get('email')?.hasError('email')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" placeholder="Enter your password">
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" 
                  [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          @if (loginForm.get('password')?.hasError('required')) {
            <mat-error>
              Password is required
            </mat-error>
          }
          @if (loginForm.get('password')?.hasError('minlength')) {
            <mat-error>
              Password must be at least 8 characters long
            </mat-error>
          }
        </mat-form-field>

        @if (error) {
          <div class="error-message">
            {{ error }}
          </div>
        }

        @if (successMessage) {
          <div class="success-message">
            {{ successMessage }}
          </div>
        }

        <button mat-raised-button color="primary" type="submit" class="submit-button" [disabled]="loginForm.invalid || loading">
          @if (loading) {
            <mat-spinner diameter="20" class="spinner"></mat-spinner>
          } @else {
            <span>Sign In</span>
          }
        </button>

        <div class="forgot-password">
          <a mat-button (click)="forgotPassword()">Forgot Password?</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
